export const getSocialCompBlockingLayerProps = (isSocialInteractionAllowed, withTooltip = true) => ({
    blockingLayer: !isSocialInteractionAllowed
        ? {
            enabled: true,
            ...(withTooltip
                ? { tooltipText: 'PREVIEW_TOOLTIP_GOTO_LIVE_SITE' }
                : {}),
        }
        : undefined,
});
//# sourceMappingURL=socialComponents.js.map